import formatPrice from '../helpers/formatPrice';

const $deliveryPostal = $('.js-delivery-postal');
const $extraDelivery = $('.js-summary-extra-delivery');
const $extraDeliveryOutput = $('.js-summary-extra-delivery-output');

const postalChecks = {
  initialize() {
    if ($deliveryPostal.length) {
      this.createListeners();
      this.checkPostal();
    }
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    $deliveryPostal.on('keyup', () => {
      this.checkPostal();
    });
  },

  /**
   * Check a postal to see if it's in a expensive region
   * @return {void}
   */
  checkPostal() {
    const region = this.getExpensiveRegion(this.postalToNumbers($deliveryPostal.val()));
    let amountWithTax = 0;

    if (region) {
      amountWithTax = region.amount_with_tax;
    }

    // Output extra delivery costs to the cart summary
    $extraDelivery.toggle(!!amountWithTax);
    $extraDeliveryOutput
      .html(formatPrice(amountWithTax))
      .data('price', amountWithTax);

    $(document).trigger('recalculate:summary');
  },

  /**
   * Get the expensive region for a postal code
   * @param {String} postal
   * @return {Boolean|Object} false or the region object
   */
  getExpensiveRegion(postal) {
    if (typeof window.OPTIONS.postal_taxes === 'undefined') {
      return false;
    }

    // Check if the postal code matches a postal region
    const foundPostalRange = window.OPTIONS.postal_taxes.filter((postalItem) => (
      (postal >= postalItem.min && postal <= postalItem.max)
    ));

    return foundPostalRange.length ? foundPostalRange[0] : false;
  },

  /**
   * Transform a postal code to a 4 character number
   * @param {String} val
   * @return {Number}
   */
  postalToNumbers(val) {
    return parseInt(val.trim().substring(0, 4), 10);
  },

  /**
   * Validates if a postal code is disabled
   * @param {String} value
   * @return {Boolean} false is disabled and true is enabled
   */
  validateDisabled(value) {
    if (typeof window.OPTIONS.postal_disabled === 'undefined') {
      return true;
    }

    const postalNumbers = this.postalToNumbers(value);

    if (Number.isNaN(postalNumbers)) {
      return true;
    }

    return window.OPTIONS.postal_disabled.reduce((accumulator, range) => {
      if (Array.isArray(range) && (postalNumbers >= range[0] && postalNumbers <= range[1])) {
        return false;
      }

      if (postalNumbers === range) {
        return false;
      }

      return accumulator;
    }, true);
  },
};

export default postalChecks;
